import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background-50">
      <span className="w-14 h-14 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
        <i className="ri-pulse-line text-2xl" />
      </span>
      <h1 className="mt-6 font-heading text-6xl font-bold text-foreground-950">404</h1>
      <p className="mt-3 text-foreground-600">页面不存在</p>
      <p className="mt-1 text-sm font-mono text-foreground-400">{location.pathname}</p>
      <Link
        to="/"
        className="mt-8 px-5 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md"
      >
        返回首页
      </Link>
    </div>
  );
}
